<template>
  <div>
    <div>
      <a-radio-group v-model="activeImageSide" size="large">
        <a-radio-button value="front">Front</a-radio-button>
        <a-radio-button value="back">Back</a-radio-button>
      </a-radio-group>
      <span style="text-align:right;margin:auto;">{{ currentImage.batch }}</span>
    </div>
    <div>
      <viewer :options="options" :trigger="activeImage" @inited="inited" ref="viewer">
        <img :src="activeImage" :key="currentImage.batch" :alt="currentImage.batch" style="width:100%;height: auto;max-height: 700px">
      </viewer>
    </div>
    <div>
    </div>
  </div>

</template>
<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ChartViewer',
  components: {
    Viewer
  },
  data () {
    return {
      activeImageSide: 'front',
      options: {
        inline: true,
        title: false,
        navbar: false,
        viewed: function () {
          this.viewer.zoomTo(1)
        }
      }
    }
  },
  watch: {
    currentImage: function (img) {
      console.log('Curent image changed to ' + img.batch)
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'queue',
      'currentImage'
    ]),
    activeImage: function () {
      if (this.activeImageSide === 'back') {
        return this.currentImage.back
      }
      return this.currentImage.front
    }
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    }
  }
}
</script>
